import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LegalView from '../views/LegalView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/mentions-legales',
    name: 'legal',
    component: LegalView,
    meta: { page: 'legal' }
  },
  {
    path: '/politique-de-confidentialite',
    name: 'privacy',
    component: LegalView,
    meta: { page: 'privacy' }
  },
  // ancienne adresse, encore présente dans les liens de pied de page déjà seedés
  {
    path: '/legal',
    redirect: (to) => ({
      path: to.hash === '#confidentialite' ? '/politique-de-confidentialite' : '/mentions-legales',
      hash: ''
    })
  },
  { path: '/:pathMatch(.*)*', component: HomeView },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
    return { top: 0 }
  }
})

export default router
